import icon from "../constants/icon"

const languages = [
      { code: 'vn', title: 'Tiếng việt', icon: icon.VietnamFlat, currency: 'Việt Nam Đồng', unit: 'VND' },
      { code: 'en', title: 'English', icon: icon.EngFlat, currency: 'United States Dollar', unit: 'USD' }
]
export default languages